import React, { useState, useEffect, useRef } from 'react'
import './Header.css'

import { BsSearch } from 'react-icons/bs'
import { BiChevronDown } from 'react-icons/bi'
import { IoStar } from 'react-icons/io5'

import { FiUser } from 'react-icons/fi'

import { Link, useLocation } from 'react-router-dom'
import Axios from 'axios'

import { CheckUserLogin } from '../sessions/CheckUserLoggin'
import { API_URL } from '../config'

const url = `${API_URL}/apps/kscanner`

export default function Header() {
  const rootUrl = window.location.origin

  if (rootUrl !== API_URL && rootUrl !== 'http://localhost:3000') {
    CheckUserLogin()
  }

  const location = useLocation()
  const dropdownRef = useRef(null)
  const searchRef = useRef(null)

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [accountName, setAccountName] = useState('')
  const [accountType, setAccountType] = useState('')
  const [search, setSearch] = useState('')
  const [queryResults, setQueryResults] = useState([])
  const [searchOpen, setSearchOpen] = useState(false)

  const account_type = localStorage.getItem('accounttype') || 'guest'

  const account_name =
    localStorage.getItem('partnername') ||
    localStorage.getItem('businessname') ||
    localStorage.getItem('customername') ||
    'Guest'

  const accountId = localStorage.getItem('customerid')

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }

      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchOpen(false)
      }
    }

    accountDetails()

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const accountDetails = () => {
    Axios.get(`${url}/webservices.php?query=ACCOUNT-DETAILS`, {
      withCredentials: true,
    })
      .then((response) => {
        setAccountName(response.data.accountName || '')
        setAccountType(response.data.accountType || '')
      })
      .catch((error) => {
        console.error('Error fetching account details:', error)
      })
  }

  const toggleDropdown = () => {
    setDropdownOpen((current) => !current)
  }

  const handleLogout = async () => {
    try {
      await fetch(`${url}/logout.php`, {
        method: 'GET',
        credentials: 'include',
      })

      localStorage.clear()
      window.location.href = '/login'
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  const handleSearch = async (event) => {
    const searchVal = event.target.value

    setSearch(searchVal)

    if (!searchVal.trim()) {
      setQueryResults([])
      setSearchOpen(false)
      return
    }

    setSearchOpen(true)

    try {
      const response = await Axios.get(
        `${url}/webservices.php?query=SEARCHEVENTS&search=${encodeURIComponent(searchVal)}`,
        {
          withCredentials: true,
        },
      )

      if (response.data.val === 0) {
        setQueryResults([])
      } else {
        setQueryResults(Array.isArray(response.data) ? response.data : [])
      }
    } catch (error) {
      console.error('Search request failed:', error)
      setQueryResults([])
    }
  }

  const getAccountLabel = () => {
    if (account_type === 'business') {
      return 'Organizer'
    }

    if (account_type === 'customer') {
      return 'Attendee'
    }

    if (account_type === 'partner') {
      return 'Affiliate'
    }

    return ''
  }

  const getDashboardPath = () => {
    if (account_type === 'business') {
      return '/dashboard'
    }

    if (account_type === 'customer') {
      return '/customerdashboard'
    }

    return '/in'
  }

  const getDisplayName = () => {
    if (!accountName) {
      return account_name
    }

    return accountName
  }

  const getEventPath = () => {
    return accountType.toLowerCase() === 'business' ? '/editevent' : '/event'
  }

  const date = new Date()
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  const fulldate = `${year}-${month}-${day}`

  return (
    <header className="kx-header">
      <div className="kx-header__inner">
        {/* =====================================================
            BRAND
        ===================================================== */}

        <Link
          to={account_type === 'customer' ? '/customerdashboard' : '/'}
          className="kx-header__brand"
        >
          <span className="kx-header__brand-name">
            karamale<span>.</span>
          </span>
        </Link>

        {/* =====================================================
            SEARCH
        ===================================================== */}

        {account_type !== 'partner' && (
          <div className="kx-header__search" ref={searchRef}>
            <div
              className={`kx-header__search-box ${
                searchOpen ? 'kx-header__search-box--active' : ''
              }`}
            >
              <BsSearch className="kx-header__search-icon" size={16} />

              <input
                type="text"
                placeholder="Search events..."
                value={search}
                onChange={handleSearch}
                onFocus={() => {
                  if (search.trim()) {
                    setSearchOpen(true)
                  }
                }}
                autoComplete="off"
              />

              {search && (
                <button
                  type="button"
                  className="kx-header__search-clear"
                  onClick={() => {
                    setSearch('')
                    setQueryResults([])
                    setSearchOpen(false)
                  }}
                >
                  ×
                </button>
              )}
            </div>

            {searchOpen && (
              <div className="kx-header__search-results">
                {queryResults.length < 1 ? (
                  <div className="kx-header__no-results">
                    <span className="kx-header__no-results-title">No events found</span>

                    <span>
                      {accountType.toLowerCase() === 'business'
                        ? 'Make sure your account has events.'
                        : 'Try searching for another event.'}
                    </span>
                  </div>
                ) : (
                  queryResults.map((item, index) => {
                    if (item.indexid >= 1) {
                      return null
                    }

                    const posterUri = `${API_URL}/apps/kscanner/posters/${item.businessid}/${item.eventid}/${item.poster}`

                    const eventName =
                      item.event_name && item.event_name.length > 27
                        ? `${item.event_name.substr(0, 27)}...`
                        : item.event_name

                    const businessName =
                      item.businessname && item.businessname.length > 30
                        ? `${item.businessname.substr(0, 30)}...`
                        : item.businessname

                    return (
                      <Link
                        key={index}
                        to={{
                          pathname:
                            accountType.toLowerCase() === 'business'
                              ? '/editevent'
                              : `/event/${item.eventid}/tickets`,
                          state: {
                            is_sponsorship: item.is_sponsorship,
                            campaignStatus: item.campaignStatus ?? 'stop',
                            fromHome: true,
                            eventid: item.eventid,
                            eventDate: item.event_day,
                            event_date: item.event_day,
                            enddate: item.finish_day,
                            finish_date: item.finish_day,
                            theme: '',
                            expectednum: '',
                            time: item.start_time,
                            starttime: item.start_time,
                            fulldate,
                            customerid: accountId,
                            posterUri,
                            accountid: accountId,
                            accounttype: accountType,
                            customername: localStorage.getItem('customername') || '',
                            email: localStorage.getItem('customeremail') || '',
                            phone: '',
                            venue: item.event_location,
                            description: item.event_des,
                            businessid: item.businessid,
                            poster: item.poster,
                            eventname: item.eventname,
                            eventday: item.eventday,
                            endtime: item.finish_time,
                            previousPage: window.location.pathname.replace(/\//g, ''),
                            category: '',
                          },
                        }}
                        className="kx-header__search-result"
                        onClick={() => setSearchOpen(false)}
                      >
                        <div className="kx-header__result-row">
                          <div className="kx-header__result-poster">
                            {item.poster ? (
                              <img src={posterUri} alt="" />
                            ) : (
                              <div className="kx-header__result-poster-empty" />
                            )}
                          </div>

                          <div className="kx-header__result-info">
                            <div className="kx-header__result-title">
                              <span>{eventName}</span>

                              {item.is_sponsorship == 1 && (
                                <span className="kx-header__sponsored">
                                  <IoStar size={11} />
                                </span>
                              )}
                            </div>

                            {accountType.toLowerCase() !== 'business' && (
                              <div className="kx-header__result-host">
                                <span>Host:</span> {businessName}
                              </div>
                            )}
                          </div>

                          <span className="kx-header__result-arrow">→</span>
                        </div>
                      </Link>
                    )
                  })
                )}
              </div>
            )}
          </div>
        )}

        {/* =====================================================
            RIGHT SIDE
        ===================================================== */}

        <div className="kx-header__right">
          {account_type === 'guest' && (
            <nav className="kx-header__guest-nav">
              <Link to="/fees">Pricing</Link>
              <Link to="/aboutkaramale">About</Link>
            </nav>
          )}

          <div
            className={`kx-header__account ${
              account_type === 'guest' ? 'kx-header__account--guest' : ''
            }`}
            ref={dropdownRef}
          >
            <button type="button" className="kx-header__account-trigger" onClick={toggleDropdown}>
              <span className="kx-header__avatar">
                {account_type === 'guest' ? (
                  <FiUser size={17} />
                ) : (
                  getDisplayName().charAt(0).toUpperCase()
                )}
              </span>

              <span className="kx-header__account-copy">
                <span className="kx-header__account-name">
                  {getDisplayName().length > 20
                    ? `${getDisplayName().slice(0, 20)}...`
                    : getDisplayName()}
                </span>

                {getAccountLabel() && (
                  <span className="kx-header__account-type">{getAccountLabel()}</span>
                )}
              </span>

              <BiChevronDown
                className={`kx-header__account-arrow ${
                  dropdownOpen ? 'kx-header__account-arrow--open' : ''
                }`}
                size={20}
              />
            </button>

            {dropdownOpen && (
              <div className="kx-header__dropdown">
                {account_type !== 'guest' && (
                  <>
                    <div className="kx-header__dropdown-heading">ACCOUNT</div>

                    <Link to={getDashboardPath()} onClick={() => setDropdownOpen(false)}>
                      <span>Dashboard</span>
                      <span>→</span>
                    </Link>

                    <Link to="/profile" onClick={() => setDropdownOpen(false)}>
                      <span>My Account</span>
                      <span>→</span>
                    </Link>

                    <Link
                      to={{
                        pathname: '/changepassword',
                        state: {
                          credentials: 'password',
                        },
                      }}
                      onClick={() => setDropdownOpen(false)}
                    >
                      <span>Change Password</span>
                      <span>→</span>
                    </Link>

                    <div className="kx-header__dropdown-divider" />

                    <button
                      type="button"
                      onClick={handleLogout}
                      className="kx-header__dropdown-logout"
                    >
                      <span>Log out</span>
                      <span>↗</span>
                    </button>
                  </>
                )}

                {account_type === 'guest' && (
                  <>
                    <div className="kx-header__dropdown-heading">KARAMALE</div>

                    <Link to="/login" onClick={() => setDropdownOpen(false)}>
                      <span>Log In</span>
                      <span>→</span>
                    </Link>

                    <Link to="/registration" onClick={() => setDropdownOpen(false)}>
                      <span>Create Account</span>
                      <span>→</span>
                    </Link>

                    <div className="kx-header__dropdown-divider" />

                    <Link to="/aboutkaramale" onClick={() => setDropdownOpen(false)}>
                      <span>About</span>
                      <span>→</span>
                    </Link>

                    <Link to="/fees" onClick={() => setDropdownOpen(false)}>
                      <span>Pricing</span>
                      <span>→</span>
                    </Link>

                    <Link to="/budget" onClick={() => setDropdownOpen(false)}>
                      <span>Calculate</span>
                      <span>→</span>
                    </Link>

                    <Link to="/aboutsalesparnter" onClick={() => setDropdownOpen(false)}>
                      <span>Affiliate Program</span>
                      <span>→</span>
                    </Link>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}
